import type { IconData } from '@stacksjs/iconify-core'

export const programmingRss: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 16C16 7.163 8.837 0 0 0v4.003C6.567 4.134 11.866 9.433 11.997 16z\"/><path fill=\"currentColor\" d=\"M10.497 16C10.366 10.262 5.738 5.634 0 5.503V9.5A6.5 6.5 0 0 1 6.5 16z\"/><path fill=\"currentColor\" d=\"M5 16a5 5 0 0 0-.229-1.5A5.01 5.01 0 0 0 1.5 11.229A5 5 0 0 0 0 11v5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default programmingRss
